module.exports = __webpack_public_path__ + "static/media/market-analysis.6c3e3f27.svg";